export const calculateSent = (RefDate) => {
    const now = new Date();
    const notificationDate = new Date(RefDate);
    const diffTime = Math.abs(now - notificationDate);
    const diffMinutes = Math.ceil(diffTime / (1000 * 60));
    const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const diffWeeks = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 7));
    const diffMonths = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30));
    const diffYears = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 365));
    if (diffMinutes < 60) {
        return`${diffMinutes} min${diffMinutes > 1 ? 's' : ''} ago`;
    } else if (diffHours < 24) {
        return`${diffHours} hr${diffHours > 1 ? 's' : ''} ago`;
    } else if (diffDays < 7) {
        return`${diffDays} day${diffDays > 1 ? 's' : ''} ago`;     
    } else if (diffWeeks < 4) {
        return`${diffWeeks} wk${diffWeeks > 1 ? 's' : ''} ago`;
    } else if (diffMonths < 12) {
        return`${diffMonths} mth${diffMonths > 1 ? 's' : ''} ago`;
    } else {
        return`${diffYears} yr${diffYears > 1 ? 's' : ''} ago`;
    }
}